module.exports = __webpack_public_path__ + "static/img/C4D0022.2070bf2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intru/C4D0022.jpg
// module id = W7Bo
// module chunks = 0